import React, { FC, useEffect, useMemo } from 'react';

import { UiButton } from 'src/components/UI/Button';
import { apiContinueWithPlusSubscriptionPlan } from 'src/api/plusSubscriptionPlanSelection';
import { PlusSubscriptionModalInfoResponseType } from 'src/models/plusSubscription';
import { GoogleTagManager, PlusSubscriptionGoogleTagEvent } from 'src/utils/GoogleTagManager';
import { tryCatch } from 'src/utils/tryCatch';
import { useOneRequest } from 'src/utils/hooks/useOneRequest';
import styles from './styles.module.scss';

type Props = {
  planId: string;
  buttonText: string;
  customerInfo: NonNullable<
    PlusSubscriptionModalInfoResponseType['PlanPreselectedModalInfo']
  >['PlusSubscriptionCustomerInfo'];
};

export const UpsellPlanPreselectedActivateButton: FC<Props> = ({ planId, buttonText, customerInfo }) => {
  const dataAttributes = useMemo(
    () => ({
      'data-cb-type': 'checkout',
      'data-cb-item-0-quantity': '1',
      'data-cb-item-0': planId,
    }),
    [planId]
  );

  const { apiCaller, loading } = useOneRequest(apiContinueWithPlusSubscriptionPlan, {
    onSuccess: (response) => {
      if (response.PlusSubscriptionEventModel) {
        const e = response.PlusSubscriptionEventModel;
        GoogleTagManager.pushEvent({
          event: e.EventName,
          customer_type: e.CustomerType,
          billing: e.Billing,
          plan: e.Plan,
          total: e.Total,
          email: e.Email,
        } as PlusSubscriptionGoogleTagEvent);
      }

      window.location.reload();
    },
  });

  useEffect(() => {
    tryCatch(() => {
      window.Chargebee.registerAgain();

      window.Chargebee.getInstance().setCheckoutCallbacks((cart) => ({
        success: (hostedPageId) => {
          apiCaller({
            PlanID: cart.products[0].items[0].item_price_id,
            HostedPageID: hostedPageId,
          });
        },
      }));

      window.Chargebee.getInstance().getCart().setCustomer({
        first_name: customerInfo.FirstName,
        last_name: customerInfo.LastName,
        company: customerInfo.CompanyName,
        email: customerInfo.Email,
      });
    }, 'chargebee error');
  }, [apiCaller, customerInfo]);

  return (
    <div className={styles.manageButtonWrapper}>
      <UiButton className={styles.button} dataAttributes={dataAttributes} loading={loading}>
        {buttonText}
      </UiButton>
    </div>
  );
};
